var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-method-component',{attrs:{"currentMethod":_vm.currentMethod},on:{"back":_vm.handleBack,"editMethod":_vm.handleEditMethod,"downloadMethodFile":_vm.handleDownloadMethodFile}},[_c('h1',[_vm._v("GRAce")])])}
var staticRenderFns = []

export { render, staticRenderFns }